/* Citric · Fotos por color.
   Cuando el cliente elige un color, se muestran solo las fotos de ese color.
   Una foto pertenece a un color si su nombre de archivo empieza con el SKU de la variante
   (ej. GOKNFOXDERO-1.jpg, GOKNFOXDERO-2.jpg → variante con SKU GOKNFOXDERO).
   Las fotos sin SKU en el nombre se muestran siempre. Si el color elegido no tiene fotos propias, no se oculta nada. */
(function () {
  var m = location.pathname.match(/\/products\/([^/?#]+)/);
  if (!m) return;
  var product = null, currentId = null, pending = false;

  function fileOf(src) {
    return (src || '').split('?')[0].split('/').pop().toUpperCase();
  }
  function ownerOf(file, variants) {
    var best = null;
    variants.forEach(function (v) {
      var sku = (v.sku || '').toUpperCase().trim();
      if (sku.length >= 4 && file.indexOf(sku) === 0 && (!best || sku.length > best.sku.length)) best = { id: v.id, sku: sku };
    });
    return best;
  }
  function selectedVariantId() {
    if (currentId) return currentId;
    var input = document.querySelector('main form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) return Number(input.value);
    var q = new URLSearchParams(location.search).get('variant');
    if (q) return Number(q);
    return product && product.variants[0] && product.variants[0].id;
  }
  function apply() {
    pending = false;
    if (!product || product.variants.length < 2) return;
    var vid = selectedVariantId();
    var gallery = document.querySelector('main media-gallery');
    if (!gallery) return;
    var imgs = gallery.querySelectorAll('img');
    var own = 0, entries = [];
    imgs.forEach(function (img) {
      var owner = ownerOf(fileOf(img.getAttribute('src') || img.currentSrc), product.variants);
      var box = img.closest('.product-media-container') || img.closest('button') || img.parentElement;
      entries.push({ box: box, owner: owner });
      if (owner && owner.id === vid) own++;
    });
    entries.forEach(function (e) {
      var hide = own > 0 && e.owner && e.owner.id !== vid;
      if (hide) { e.box.style.display = 'none'; e.box.setAttribute('data-citric-media-hidden', '1'); }
      else if (e.box.getAttribute('data-citric-media-hidden')) { e.box.style.display = ''; e.box.removeAttribute('data-citric-media-hidden'); }
    });
  }
  function schedule() { if (!pending) { pending = true; setTimeout(apply, 60); } }

  fetch(location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (p) {
      product = p;
      schedule();
      new MutationObserver(schedule).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }).catch(function () {});

  document.addEventListener('variant:update', function (e) {
    var v = e && e.detail && (e.detail.resource || e.detail.variant);
    if (v && v.id) currentId = Number(v.id);
    schedule();
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-picker, .variant-picker')) { currentId = null; setTimeout(schedule, 400); }
  });
})();
